document.addEventListener("DOMContentLoaded", () => {
  const formContainer = document.querySelector(".form-container");
  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector("#app-embed");
    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;
      if (shadow) {
        const sheet = new CSSStyleSheet();
        const globalStyles = `
          ._multiFieldLine_exnrn_1:has(#shipping_address_first_name) {
            display: none;
          }
         
          #app-embed {
            padding: 0 36px !important;
          }
            #app-embed input, #app-embed textarea {
              border-radius: 0px !important;
              border: none !important;
              height: 32px !important;
              padding: 0 9px 0 9px !important;
              color: #000000;
              font-size: 16px;
              line-height: 20px;
              letter-spacing: -0.02em;
              font-weight: 400;
            border: 1px solid #000000 !important;
            box-shadow: none !important;
            }
            ._textBody_2aowh_10 a {
              color: #000000;
              text-decoration-thickness: 3px;
              text-underline-offset: 1px;
              text-decoration-color: var(--forms-accent-color);
              margin-left: 18px;
              margin-right: 18px;
              font-weight: 700;
            }
              ._fieldContainer_exnrn_16:has(._selectContainer_12thd_6 button[aria-controls="shipping_address_zone-selector-dropdown"])
              {
                align-self: flex-end;
              }
            #app-embed button {
              border-radius: 0px !important;
              border: none !important;
              min-height: 34px !important; 
            border: 1px solid #000000 !important;
            box-shadow: none !important;
            }
              ._selectToggle_12thd_25 {
                padding: 0 9px 0 9px !important;
              }
            ._nonMultineFieldLine_exnrn_11:has(#billing_address_recipient),
            ._multiFieldLine_exnrn_1:has(#billing_address_first_name),
            ._multiFieldLine_exnrn_1:has(#billing_address_last_name),
            ._nonMultineFieldLine_exnrn_11:has(#billing_address_address2),
            ._nonMultineFieldLine_exnrn_11:has(#billing_address_last_name) {
              display: none !important;
            }
            #app-embed div:not(._multiFieldLine_exnrn_1) {
              flex-direction: column-reverse;
              width: 100%;
            }
            #app-embed div._formFileInputFileName_ehvsf_34 {
                flex-direction: row;
            }
            #app-embed ._multiFieldLine_exnrn_1 {
              flex-direction: column;
            }
            #app-embed ._fieldContainer_exnrn_16 {
              width: 100%;
            }
            ._multiFieldLine_exnrn_1 ._fieldContainer_exnrn_16:has(._selectContainer_1yit2_6) {
              margin-top: 14px;
            }
            #app-embed section._formHeader_1ll8d_19 strong {
              display: block;
              font-size: 28px;
              font-weight: 700;
              line-height: 28px;
              letter-spacing: -0.02em;
              text-align: center;
              text-underline-position: from-font;
              text-decoration-skip-ink: none;
              color: white;
              margin-bottom: 24px;
            }
            #app-embed ._formPhoneInputContainer_1ym3p_6 {
              align-items: self-end;
            }
            #app-embed label, #app-embed legend {
              position: static;
              margin-bottom: 15px;
              color: #000000;
              text-align: left;
              text-underline-position: from-font;
              text-decoration-skip-ink: none;
              text-transform: capitalize;
              display: flex;
              align-items: center;
            }
            #app-embed ._textBody_2aowh_10 {
              position: static;
              margin-bottom: 14px;
              color: #000000;
              font-size: 16px;
              font-weight: 400;
              line-height: 20px;
              letter-spacing: -0.02em;
              text-align: left;
              text-underline-position: from-font;
              text-decoration-skip-ink: none;
              width: 100%;
            }
              #app-embed h2 {
                display: none;
              }
            .section._formBannerContainer_z5ku3_1[data-testid="banner-success"] ._textBody_2aowh_10 {
              max-width: 1152px;
              padding: 0px;
              margin: 0 auto;
              padding: 36px !important;
              background-color: #f0f0f0 !important;
            }
            .section._formBannerContainer_z5ku3_1[data-testid="banner-success"] ._textBody_2aowh_10 p {
              font-family: 'ABC Diatype Medium';
              padding: 0px;
              margin: 0;
              font-size: 20px;
              font-weight: 700;
              line-height: 24px;
              letter-spacing: 0;
              color: #000000;
            }
            #app-embed {
              font-family: 'ABC Diatype Medium' !important;

            }
            #app-embed section._formHeader_1ll8d_19 * {
              text-align: center;
            }
            #app-embed button._formSubmitButton_1ll8d_81 {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              padding: 2px 27px;
              cursor: pointer;
              text-transform: uppercase;
              font: inherit;
              font-size: 16px;
              letter-spacing: 0.15em;
              font-weight: 700;
              text-decoration: none;
              color: rgb(var(--color-button-text));
              border: 1px solid #B4045C;
              transition: box-shadow var(--duration-short) ease;
              -webkit-appearance: none;
              appearance: none;
              background-color: rgba(var(--color-button), var(--alpha-button-background));
              border-radius: 50px !important;
              max-width: 321px;
              margin-top: 14px;
            }
            #app-embed ._inline_stahb_47 ._formContainer_stahb_30 {
              max-width: 628px;
              padding: 36px 18px;
            }
            #app-embed h2 {
              font-size: 36px;
              font-weight: 700;
              line-height: 40px;
              letter-spacing: -0.01em;
              text-align: center;
              text-underline-position: from-font;
              text-decoration-skip-ink: none;
              color: white;
              margin-bottom: 36px;
            }
            #app-embed ._inline_stahb_47 {
              display: flex;
            }
            #app-embed ._formFileInputField_ehvsf_5 {
              background: transparent;
              border: 1px solid white !important;
              min-height: 102px !important;
              align-items: center;
            }
            #app-embed ._formFieldContainer_1ydxd_5:focus-within ._formInputFieldLabel_1ydxd_37,
            #app-embed ._formFieldContainer_1ydxd_5 ._inputFilled_1ydxd_73 {
              transform: unset !important;
            }
            #app-embed ._formFieldContainer_1ydxd_5, #app-embed ._selectContainer_1wdej_6 {
              margin-bottom: 20px !important;
            }
            #app-embed ._formFileInputField_ehvsf_5 p {
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              letter-spacing: -0.02em;
              text-align: left;
              text-underline-position: from-font;
              text-decoration-skip-ink: none;
              padding: 18px;
              width: 100%;
              border-radius: 10px;
              margin: 0 27px;
              text-align: center;
            }
            #app-embed ._formFileInput_ehvsf_1 {
              margin-top: 14px;
              margin-left: unset;
            }
            #app-embed section._formHeader_1ll8d_19 {
              margin: 0 auto 10px;
            }
            #app-embed button._formSubmitButton_1ll8d_81:hover {
                background: #fff;
                box-shadow: 0 0 20px #ffffff80;
                border: 1px solid #FFFFFF;
                color: #101010;
                filter: unset !important;
            }
            #app-embed ._formPhoneInputContainer_1ym3p_6 {
                position: relative;
                padding-top: 30px;
            }
            ._formFieldContainer_ck6wz_5:focus-within ._formInputFieldLabel_ck6wz_38 {
                transform: unset !important;
            }
            #app-embed #label-billing_address_phone {
                position: relative;
                left: -38.75%;
                top: 0;
            }
            #app-embed ._inline_stahb_47 ._formContainer_stahb_30 {
                overflow: visible;
            }
            #app-embed ._formFileInputFileName_ehvsf_34 span {
                color: white;
                font-size: 16px;
            }
            #app-embed ._formFileInputFileName_ehvsf_34 svg {
                fill: white;
                scale: 1.5;
                margin-left: 12px;
            }
            #app-embed p,
            #app-embed label, 
            #app-embed legend {
                font-family: 'ABC Diatype Medium';
                color: #000000;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: -0.02em;
                font-weight: 400;
                margin-bottom: 14px;
            }
            #country-selector-dropdown {
              max-height: 110px !important;
            }
            ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
                max-width: 1152px;
            }
            form._formFieldset_cit2d_82 {
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                gap: 18px;
                row-gap: 24px;
            }
           
            
            div._nonMultineFieldLine_exnrn_11 ._formPhoneInputContainer_1ym3p_6 {
                width: 50% !important;
            }
            ._formPhoneInputContainer_1ym3p_6  ._formFieldContainer_ck6wz_5 {
                position: unset !important;
            }
            div._nonMultineFieldLine_exnrn_11:has(div._formPhoneInputContainer_1ym3p_6) {
             position: relative;
            }
            div._nonMultineFieldLine_exnrn_11  #label-shipping_address_phone {
              display: none !important;
                position: absolute; 
                left: 0;
                top: 0;
            }
            #app-embed ._multiFieldLine_exnrn_1:has(div._formFieldContainer_ck6wz_5 #shipping_address_first_name),
            #app-embed ._multiFieldLine_exnrn_1:has( div._formFieldContainer_ck6wz_5 #shipping_address_last_name),
            ._nonMultineFieldLine_exnrn_11:has(div._formFieldContainer_ck6wz_5 #shipping_address_recipient) {
                display: none !important;
            }
            #app-embed button._formSubmitButton_cit2d_96 {
                min-height: unset !important;
                font-size: 16px;
                line-height: 20px;
                font-weight: 700;
                padding: 4px 9px;
                font-family: 'ABC Diatype Medium';
                border: none !important;
            }
            #app-embed button._formSubmitButton_cit2d_96:hover {    
                background-color: #000000 !important;
                border: none !important;
                filter: unset !important;
            }
            ._gridItemContent_1q1d2_257 {
              padding: 24px 0 72px !important;
            }
            @media screen and (min-width: 992px) {
              #app-embed section._formHeader_1ll8d_19 strong {
                font-size: 48px;
                font-weight: 700;
                line-height: 56px;
                letter-spacing: -0.03em;
                text-align: left;
              }
              #app-embed ._inline_stahb_47 ._formContainer_stahb_30 {
                padding: unset;
                overflow: visible;
              }
              #app-embed ._formPhoneInputContainer_1ym3p_6 ._selectContainer_1yit2_6 {
                width: 163px;
              }
              #app-embed ._formPhoneInputContainer_1ym3p_6 ._formFieldContainer_1ydxd_5 {
                margin-bottom: 0 !important;
              }
              #app-embed #label-phone_number {
                position: relative;
                top: 0px;
              }

        }
              #app-embed ._formPhoneInputContainer_1ym3p_6 ._selectContainer_1yit2_6 {
                width: 163px;
              }
              #app-embed #label-billing_address_phone {
                position: relative;
                left: -173px;
                top: 0;
              }
              #app-embed h2 {
                display: none;
              }
              #app-embed ._multiFieldLine_exnrn_1 {
                flex-direction: row;
              }
              #app-embed ._fieldContainer_exnrn_16 {
                width: 5rem;
              }
              ._multiFieldLine_exnrn_1 ._fieldContainer_exnrn_16:has(._selectContainer_1yit2_6) {
                margin-top: unset;
              }
              #app-embed ._multiFieldLine_exnrn_1:has(._formError_1ydxd_20) {
                max-height: 103px;
                margin-bottom: 24px;
              }
              #app-embed ._fieldContainer_exnrn_16:has(._formError_1ydxd_20) {
                position: relative;
                bottom: -29px;
              }
              #app-embed ._inline_stahb_47 {
                padding: 144px 74px;
                width: unset;
              }
              #app-embed button._formSubmitButton_1ll8d_81 {
                margin-left: unset !important;
              }
              #app-embed ._formFileInputField_ehvsf_5 p {
                width: fit-content;
                margin: unset;
              }
              #app-embed section._formHeader_1ll8d_19 * {
                text-align: left;
              }
              #app-embed button._formSubmitButton_1ll8d_81 {
                margin: 14px auto 0px;
              }
              #app-embed button._formSubmitButton_1ll8d_81:hover {
                box-shadow: 0 0 40px #ffffff80;
              }
            }
            @media screen and (max-width: 1399px) {
              form._formFieldset_cit2d_82 {
                padding: 0 72px !important;
              }
                #app-embed div._textBody_2aowh_10{
                 padding: 0 72px !important;
                }
            }
            
            @media screen and (max-width: 767px) {
              form._formFieldset_cit2d_82 {
               padding: 0 36px !important;
              }
               #app-embed {
                padding: 0 !important;
               }
              #app-embed div._textBody_2aowh_10{
                 padding: 0 36px !important;
                }
                #app-embed ._multiFieldLine_exnrn_1 {
                 flex-wrap: wrap;
                }
            }
          `;
        sheet.replaceSync(globalStyles);
        shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];
        const labels = Array.from(shadow.querySelectorAll("label")).filter(
          (label) => !label.classList.contains("_radioField_nw6va_1")
        );
      }
      if (formContainer) {
        formContainer.classList.add("loaded");
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
